export default [
  {
    title: "Fulfillment",
    customIcon: "FulfillmentSVG",
    children: [
      {
        title: "Products",
        route: "custom-module",
        path: "/custom-module/fulfillment",
      },
    ],
  },
];
